import React from "react";

import styled from "styled-components";
import { TermsDiv, TermsBox, Header, Title, Inner } from "./styledGameRules";
import { ScalingContainer } from "../../../AppStyled";

import { ReactComponent as MenuSVG } from "../../../svg/settings.svg";
import { ReactComponent as PlusSVG } from "../../../svg/plus.svg";
import { ReactComponent as MinusSVG } from "../../../svg/minus.svg";
import { ReactComponent as AutoSVG } from "../../../svg/autorules.svg";
// import { ReactComponent as FastSVG } from "../../../svg/fast.svg";
import useSound from "use-sound";

import closeSound from "../../../audio/goBack.mp3";
export const OPDescriptionContainer = styled.div`
  display: flex;
  align-items: flex-start;
  text-transform: none;
  max-width: 320px;
  margin: 0 auto;
  margin-bottom: 20px;
`;
export const OPDescriptionBox = styled.div`
  text-transform: none;

  p:first-child {
    font-family: "GT America, boldN";
    margin-bottom: 10px;
  }
`;
export const OPDescriptionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border-radius: 38px;
  text-transform: none;
  background: #ffb000;
  margin-right: 10px;
  color: #ff3920;
  font-size: 14px;
  height: 42px;
  width: 42px;
  svg {
    width: 20px;
    height: 20px;
    g {
      stroke: #ff3920;
    }
  }
  .autosvg {
    margin-left: 6px;
  }
`;
export const OPDescription = styled.div`
  max-width: 320px;
  margin: 0 auto;
  margin-bottom: 30px;
  padding-bottom: 20px;
  line-height: 1.33;
  text-transform: none;

  h3 {
    font-size: 20px;
    margin-bottom: 8px;
  }
  p {
    font-size: 12px;
    font-family: "GT America, regular";
  }
  /* @media only screen and (min-width: 375px) {
    h3 {
      font-size: 20px;
    }
    p {
      font-size: 12px;
    }
  } */
`;
export const MenuBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border-radius: 38px;
  margin-right: 10px;
  color: #ff3920;
  font-size: 14px;
  height: 42px;
  width: 42px;
  svg {
    width: 26px;
    height: 26px;
    g {
      stroke: #7f3da5;
    }
  }
`;

const MAX_WIN = 1000;

export default function GameRules({
  handleAbove,
  h,
  sound,
  volume,
  unBlur,
  minBet,
  maxBet,
  currency,
}) {
  const [closeSFX] = useSound(closeSound, { volume });

  return (
    <TermsDiv className="GameRules" unBlur={unBlur}>
      <ScalingContainer className="ScalingContainer" h={h}>
        <TermsBox>
          <Header>
            <h1>game rules</h1>
            <div
              onClick={() => {
                if (sound) closeSFX();
                handleAbove(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
              >
                <g
                  fill="none"
                  fillRule="evenodd"
                  stroke="#32075B"
                  strokeLinecap="round"
                  strokeWidth="3"
                >
                  <path d="M12.303 12.303L1.697 1.697M1.697 12.303L12.303 1.697" />
                </g>
              </svg>
            </div>
          </Header>
          <Title>Keno</Title>
          <Inner>
            Keno is a revolutionary concept of simplicity developed by Orbital’s
            talented team.The game incorporates 3 different modes, each with its
            own highly customizable settings.
            <br />
            <br />
            <li>The modes are: Sonic, Keno 40 and Keno 80.</li>
            <br />
            The max win is {`${currency} ${maxBet * MAX_WIN}`} of your bet
            <br />
            Maximum Bet: {`${currency} ${maxBet}`} Minimum Bet:{" "}
            {`${currency} ${minBet}`}
          </Inner>
          <Title>Keno 40</Title>
          <Inner>
            Keno 40 has a number panel of 1 to 40. Your Objective is to
            highlight 10 winning numbers for each shuffle. The more numbers you
            guess, the more your win is going to be.
            <br />
            <br />
            <li>
              Random button – Marks random numbers for you, saving you time in
              the process.
            </li>
            <br />
            <li>Play button – Start Playing!</li>
            <br />
            <li>2x – Doubles your bet instantly</li>
            <br />
            <li>1/2 – Divides your bet in half</li>
            <br />
            <li>X button – Clear your bet instantly</li>
            <br />
            <li>
              Autoplay Button - enjoy non-stop action. Just press stop when you
              decide to take a break.
            </li>
          </Inner>
          <Title>Sonic</Title>
          <Inner>
            Sonic is all about supersonic speed. Minimal time delay and maximum
            efficiency is its motto. It has the same characteristics as the Keno
            40. The main difference is the faster speed and dynamic gameplay of
            the Sonic! <br />
            <br />
            <li>
              Press and hold on the > button to switch to quickplay interface
            </li>
            <br />
            <li>X button – Clear your bet instantly</li>
            <br />
            <li>
              Random button – Marks random numbers for you, saving you time in
              the process.
            </li>
            <br />
            <li>2x – Doubles your bet instantly</li>
            <br />
            <li>1/2 – Divides you bet in half</li>
            <br />
            <li>
              Press and hold the >> button to enjoy non-stop action. Just press
              stop when you decide to take a break.
            </li>
            <br />
            <li>
              On Loss – In this field you can input option to increase or
              decrease the bet during acertain loss percentage.
            </li>
            <br />
            <li>
              On Win - In this field you can input option to increase or
              decrease the bet during a certain win percentage.
            </li>
            <br />
            <li>
              Stop on Profit – Enables player to stop autoplay when certain
              profit number is reached.
            </li>
            <br />
            <li>
              Stop on Loss - Enables player to stop autoplay when a certain
              amount is lost.
            </li>
            <br />
            <li>+ (Increase the bet manually)</li>
            <br />
            <li>- (Decrease the bet manually) </li>
          </Inner>
          <Title>Keno 80</Title>
          <Inner>
            Keno 80 has a larger number panel of 1 to 80. Your Objective is to
            highlight 10 winning numbers for each shuffle. The more numbers you
            guess, the bigger your win is going to be.
            <br />
            <br />
            <li>
              Random button – Marks random numbers for you, saving you time in
              the process.
            </li>
            <br />
            <li>Play button – Start Playing!</li>
            <br />
            <li>2x – Doubles your bet instantly</li>
            <br />
            <li>1/2 – Divides your bet in half</li>
            <br />
            <li>X button – Clear your bet instantly</li>
            <br />
            <li>
              Autoplay Button - enjoy non-stop action. Just press stop when you
              decide to take a break.
            </li>
          </Inner>
          <OPDescription>
            <h3>Settings</h3>
            <OPDescriptionContainer>
              <MenuBox width="42px" height="42px">
                <MenuSVG />
              </MenuBox>
              <OPDescriptionBox>
                <p>Settings button</p>
                <p>Press the button to access Settings.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <p>
              <b> Provably Fair</b> – This section grants you the possibility of
              checking the fairness of the game for yourself. <br />
              <br />
              <b> Game Rules</b> – Short Description of the Game. <br />
              <br />
              <b> History </b>– Shows your previous plays and allows you to
              devise new tactics for your next shuffle. <br />
              <br />
              <b> Music</b> - Turn on the unique audio overlay of the game.{" "}
              <br />
              <br />
              <b> Sound </b> – Enable unique sounds of the game. <br />
              <br />
              <b> Volume Bar </b>– Set the volume.
            </p>
          </OPDescription>

          <OPDescription>
            <h3>Gameplay Customization </h3>
            <p>
              <b>Play Button</b> – Start the Game. <br />
              <br />
            </p>
            <OPDescriptionContainer>
              <OPDescriptionIcon>2X</OPDescriptionIcon>
              <OPDescriptionBox>
                <p>2x Button</p>
                <p>Doubles your bet instantly.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>1/2</OPDescriptionIcon>
              <OPDescriptionBox>
                <p>1/2 Button</p>
                <p>Divides your bet by half.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <p>
              Options: <br /> <br />
            </p>
            <OPDescriptionContainer>
              <OPDescriptionIcon>5X</OPDescriptionIcon>
              <OPDescriptionBox>
                <p>5x Button</p>
                <p>Multiply your bet by 5.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <PlusSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>+ button</p>
                <p>Increase amount by a single unit.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <MinusSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>- button</p>
                <p>Decrease amount by a single unit.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <AutoSVG className="autosvg" />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>auto button</p>
                <p>switch to auto interface.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            Auto play Options: <br />
            <p>
              <br />
              <b> Number of Bets</b> – Set the Number of Your Bets. <br />
              <br />
              <b> On Win </b>- In this field you can input an option to increase
              or decrease the bet percentage after the winning hand.
              <br />
              <br /> <b>On Loss </b>– In this field you can input an option to
              increase or decrease the bet percentage after the losing hand.
              <br />
              <br />
              <b> Stop on Profit </b>– Enables you to stop autoplay when a
              certain profit number is reached. <br />
              <br /> <b>Stop on Loss</b> - Enables you to stop autoplay when a
              certain amount is lost. <br />
            </p>
            <br />
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <PlusSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>+ button</p>
                <p>Increase amount by a single unit.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <MinusSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>- button</p>
                <p>Decrease amount by a single unit.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
          </OPDescription>
        </TermsBox>
      </ScalingContainer>
    </TermsDiv>
  );
}
